import React from "react";
import classes from "./RelatedItems.module.css";
import { useNavigate } from "react-router-dom";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { extractTextFromHTML } from "../../../components/extract-from-html/ExtractFromHtml";

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

const RelatedItems = ({ data }) => {
  const navigate = useNavigate();
  const width = useDeviceWidth();
  const sliceAmount = width > 1800 ? 4 : width > 1380 ? 3 : 4;

  return (
    <div className={classes.outer}>
      <h1 data-aos="fade-right" data-aos-delay="200">
        Related Treatments
      </h1>
      <div className={classes.list}>
        {data?.slice(0, sliceAmount)?.map((item, index) => (
          <div
            className={classes.card}
            onClick={() => navigate(`/infertility-treatment/${item?.slug}`)}
            // data-aos="fade-right"
            // data-aos-delay={index * 10 + 100}
          >
            <img
              src={item?.images?.find((item) => item?.mainImage == "yes")?.url}
              alt={
                item?.images?.find((item) => item?.mainImage == "yes")?.imageTag
              }
            ></img>
            <div className={classes.rightDiv}>
              <h5>{formatDate(item?.createdAt)}</h5>
              <h2>{item?.title}</h2>
              <div className={classes.underLine}></div>
              <p>{extractTextFromHTML(item?.homeDescription)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedItems;
